import { render, staticRenderFns } from "./PageCreatorsByTalentRep.vue?vue&type=template&id=aff8f75e&"
import script from "./PageCreatorsByTalentRep.vue?vue&type=script&lang=ts&"
export * from "./PageCreatorsByTalentRep.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports